let unique = 0

function uuid(prefix?: string): string {
  unique++

  try {
    return `${
      prefix && prefix.length > 0 ? `${prefix}-` : ''
    }10000000-1000-4000-8000-100000000000-${unique}`.replace(/[018]/g, (c) => {
      const cp = parseInt(c)
      return (
        cp ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (cp / 4)))
      ).toString(16)
    })
  } catch (e) {
    const time = Date.now()

    const random = Math.floor(Math.random() * 1000000000)

    return prefix + '_' + random + unique + String(time)
  }
}

export default uuid
